import { put, takeLeading, all, call } from 'redux-saga/effects';

import { apiErrorHandler } from 'utils';

import administratorApi from 'api/administratorApi';
import { RESET_FORM_SUCCESS } from 'store/edit-location/actionTypes';
import {
  GET_ADMINISTRATORS_LIST,

  GET_EXTRANET_ADMINISTRATORS_LIST,
  // GET_EXTRANET_ADMINISTRATORS_LIST_SUCCESS,
  // GET_EXTRANET_ADMINISTRATORS_LIST_FAILED,

  GET_ADMINISTRATORS_DETAIL,

  GET_ACTION_HISTORY_LIST,

  ADD_ADMINISTRATOR,
  ADD_ADMINISTRATOR_SUCCESS,
  ADD_ADMINISTRATOR_FAILED,

  CREATE_ADMINISTRATOR_PASSWORD,
  CREATE_ADMINISTRATOR_PASSWORD_SUCCESS,
  CREATE_ADMINISTRATOR_PASSWORD_FAILED,

  DELETE_ADMINISTRATOR,
  DELETE_ADMINISTRATOR_SUCCESS,
  DELETE_ADMINISTRATOR_FAILED,

  EDIT_ADMINISTRATOR,
  EDIT_ADMINISTRATOR_SUCCESS,
  EDIT_ADMINISTRATOR_FAILED,

  GET_MY_PERMISSION,

  GET_EXTRANET_ADMINISTRATORS_PLACE_MANAGER,

  EDIT_EXTRANET_ADMINISTRATOR,
  EDIT_EXTRANET_ADMINISTRATOR_SUCCESS,
  EDIT_EXTRANET_ADMINISTRATOR_FAILED,

  DELETE_EXTRANET_ADMINISTRATOR,
  DELETE_EXTRANET_ADMINISTRATOR_SUCCESS,
  DELETE_EXTRANET_ADMINISTRATOR_FAILED,

  RESET_EXTRANET_ADMINISTRATOR_PASSWORD,
  RESET_EXTRANET_ADMINISTRATOR_PASSWORD_SUCCESS,
  RESET_EXTRANET_ADMINISTRATOR_PASSWORD_FAILED,

  CHECK_EXTRANET_EMAIL,
  CHECK_EXTRANET_EMAIL_SUCCESS,
  CHECK_EXTRANET_EMAIL_FAILED,

  ADD_EXTRANET_ADMINISTRATOR,
  ADD_EXTRANET_ADMINISTRATOR_SUCCESS,
  ADD_EXTRANET_ADMINISTRATOR_FAILED,

  RESET_INTRANET_ADMINISTRATOR_PASSWORD,
  RESET_INTRANET_ADMINISTRATOR_PASSWORD_SUCCESS,
  RESET_INTRANET_ADMINISTRATOR_PASSWORD_FAILED,
} from './actionTypes';
import {
  actionGetAdministratorsListSuccess,
  actionGetAdministratorsListFailed,

  actionGetExtranetAdministratorsListSuccess,
  actionGetExtranetAdministratorsListFailed,

  actionGetActionHistoryListSuccess,
  actionGetActionHistoryListFailed,

  actionGetAdministratorsDetailSuccess,
  actionGetAdministratorsDetailFailed,

  actionGetMyPermissionSuccess,
  actionGetMyPermissionFailed,

  actionGetExtranetAdministratorsPlaceManagerSuccess,
  actionGetExtranetAdministratorsPlaceManagerFailed,
} from './actions';

function* getAdministratorsList({ payload }) {
  const { append, ...apiPayload } = payload || {};

  try {
    const response = yield administratorApi.getAdministratorsList(apiPayload);

    yield put(
      actionGetAdministratorsListSuccess({
        ...response.payload,
        append: !!append,
      }),
    );
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetAdministratorsListFailed());
  }
}

function* getExtranetAdministratorsList({ payload }) {
  const { append, ...apiPayload } = payload || {};

  try {
    const response = yield administratorApi.getExtranetAdministratorsList(apiPayload);

    yield put(
      actionGetExtranetAdministratorsListSuccess({
        ...response.payload,
        append: !!append,
      }),
    );
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetExtranetAdministratorsListFailed());
  }
}

function* getAdministratorsDetail({ payload }) {
  try {
    const response = yield administratorApi.getAdministratorsDetail(payload);

    yield put(
      actionGetAdministratorsDetailSuccess(response.payload),
    );
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetAdministratorsDetailFailed());
  }
}

function* addAdministrator({ payload }) {
  const { result, callBack } = payload;
  try {
    yield administratorApi.addAdministrator(result);

    yield put({
      type: ADD_ADMINISTRATOR_SUCCESS,
    });

    yield put({
      type: RESET_FORM_SUCCESS,
    });

    callBack();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: ADD_ADMINISTRATOR_FAILED,
    });
  }
}

function* createAdministratorPassword({ payload }) {
  const { result, token, callBack } = payload;
  try {
    yield administratorApi.createAdministratorPassword({ result, token });

    yield put({
      type: CREATE_ADMINISTRATOR_PASSWORD_SUCCESS,
    });

    yield put({
      type: RESET_FORM_SUCCESS,
    });

    callBack();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: CREATE_ADMINISTRATOR_PASSWORD_FAILED,
    });
  }
}

function* deleteAdministrator({ payload }) {
  const { adminId, callBack } = payload;

  try {
    yield administratorApi.deleteAdministrator(adminId);

    yield put({
      type: DELETE_ADMINISTRATOR_SUCCESS,
    });

    callBack();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: DELETE_ADMINISTRATOR_FAILED,
    });
  }
}

function* editAdministrator({ payload }) {
  const { adminId, result, callBack } = payload;
  try {
    yield administratorApi.editAdministrator({ adminId, result });

    yield put({
      type: EDIT_ADMINISTRATOR_SUCCESS,
    });

    yield put({
      type: RESET_FORM_SUCCESS,
    });

    callBack();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: EDIT_ADMINISTRATOR_FAILED,
    });
  }
}

function* getActionHistoryList({ payload }) {
  try {
    const response = yield administratorApi.getActionHistoryList(payload);

    yield put(
      actionGetActionHistoryListSuccess(response.data),
    );
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetActionHistoryListFailed());
  }
}

function* getMyPermission() {
  try {
    const response = yield administratorApi.getMyPermission();

    yield put(
      actionGetMyPermissionSuccess(response.payload),
    );
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetMyPermissionFailed());
  }
}

function* getExtranetAdministratorsPlaceManager({ payload }) {
  const { place, adminId, rowKey } = payload || {};
  try {
    const response = yield administratorApi.getExtranetAdministratorsPlaceManager({ place });
    const subAccounts = response.payload || [];

    const details = yield all(
      subAccounts.map((subAccount) =>
        call(administratorApi.getExtranetAdministratorDetail, {
          id: subAccount._id,
          place,
        }),
      ),
    );

    const mergedSubAccounts = subAccounts.map((subAccount, idx) => {
      const detailResponse = details[idx];
      const detailData = detailResponse?.payload || {};
      return {
        ...subAccount,
        ...detailData,
      };
    });

    yield put(
      actionGetExtranetAdministratorsPlaceManagerSuccess({
        adminId,
        rowKey,
        data: mergedSubAccounts,
      }),
    );
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetExtranetAdministratorsPlaceManagerFailed());
  }
}

function* editExtranetAdministrator({ payload }) {
  const { id, place, result, callBack } = payload;
  try {
    yield administratorApi.editExtranetAdministrator({ id, place, result });

    yield put({
      type: EDIT_EXTRANET_ADMINISTRATOR_SUCCESS,
    });

    yield put({
      type: RESET_FORM_SUCCESS,
    });

    callBack();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: EDIT_EXTRANET_ADMINISTRATOR_FAILED,
    });
  }
}

function* deleteExtranetAdministrator({ payload }) {
  const { id, place, callBack } = payload;
  try {
    yield administratorApi.deleteExtranetAdministrator({ id, place });

    yield put({
      type: DELETE_EXTRANET_ADMINISTRATOR_SUCCESS,
    });

    callBack();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: DELETE_EXTRANET_ADMINISTRATOR_FAILED,
    });
  }
}

function* checkExtranetEmail({ payload }) {
  const { email, callBack } = payload;
  try {
    const response = yield administratorApi.checkExtranetEmail({ email });

    yield put({
      type: CHECK_EXTRANET_EMAIL_SUCCESS,
      payload: response.payload,
    });

    callBack?.(response.payload);
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: CHECK_EXTRANET_EMAIL_FAILED,
    });
  }
}

function* addExtranetAdministrator({ payload }) {
  const { result, callBack, onError } = payload;
  try {
    yield administratorApi.addExtranetAdministrator(result);

    yield put({
      type: ADD_EXTRANET_ADMINISTRATOR_SUCCESS,
    });

    yield put({
      type: RESET_FORM_SUCCESS,
    });

    callBack?.();
  } catch (error) {
    if (onError) {
      onError(error);
    } else {
      apiErrorHandler(error);
    }
    yield put({
      type: ADD_EXTRANET_ADMINISTRATOR_FAILED,
    });
  }
}

function* resetExtranetAdministratorPassword({ payload }) {
  const { id, result, callBack } = payload;
  try {
    yield administratorApi.resetExtranetAdministratorPassword({ id, result });

    yield put({
      type: RESET_EXTRANET_ADMINISTRATOR_PASSWORD_SUCCESS,
    });

    callBack?.();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: RESET_EXTRANET_ADMINISTRATOR_PASSWORD_FAILED,
    });
  }
}

function* resetIntranetAdministratorPassword({ payload }) {
  const { id, result, callBack } = payload;
  try {
    yield administratorApi.resetIntranetAdministratorPassword({ id, result });

    yield put({
      type: RESET_INTRANET_ADMINISTRATOR_PASSWORD_SUCCESS,
    });

    callBack?.();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: RESET_INTRANET_ADMINISTRATOR_PASSWORD_FAILED,
    });
  }
}

export default function* administratorSaga() {
  yield takeLeading(ADD_ADMINISTRATOR, addAdministrator);
  yield takeLeading(CREATE_ADMINISTRATOR_PASSWORD, createAdministratorPassword);
  yield takeLeading(GET_ADMINISTRATORS_LIST, getAdministratorsList);
  yield takeLeading(GET_EXTRANET_ADMINISTRATORS_LIST, getExtranetAdministratorsList);
  yield takeLeading(GET_ADMINISTRATORS_DETAIL, getAdministratorsDetail);
  yield takeLeading(GET_ACTION_HISTORY_LIST, getActionHistoryList);
  yield takeLeading(DELETE_ADMINISTRATOR, deleteAdministrator);
  yield takeLeading(EDIT_ADMINISTRATOR, editAdministrator);
  yield takeLeading(GET_MY_PERMISSION, getMyPermission);
  yield takeLeading(
    GET_EXTRANET_ADMINISTRATORS_PLACE_MANAGER,
    getExtranetAdministratorsPlaceManager,
  );
  yield takeLeading(EDIT_EXTRANET_ADMINISTRATOR, editExtranetAdministrator);
  yield takeLeading(DELETE_EXTRANET_ADMINISTRATOR, deleteExtranetAdministrator);
  yield takeLeading(CHECK_EXTRANET_EMAIL, checkExtranetEmail);
  yield takeLeading(ADD_EXTRANET_ADMINISTRATOR, addExtranetAdministrator);
  yield takeLeading(RESET_EXTRANET_ADMINISTRATOR_PASSWORD, resetExtranetAdministratorPassword);
  yield takeLeading(RESET_INTRANET_ADMINISTRATOR_PASSWORD, resetIntranetAdministratorPassword);
}
